import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResetPasswordService} from "./services/reset-password.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Login', path: 'app/login'},
    { label: 'Reset Password', path: 'app/login/reset-password'}
  ];
  showMessages = false;

  messages: any[] = [];
  secureCodeId: number = -1;
  secureCode: string = '';
  constructor(private router: Router, private route: ActivatedRoute,
              private resetPasswordService: ResetPasswordService) {
    this.ngOnInit();
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const secureCodeIdTemp = this.route.snapshot.paramMap.get('secureCodeId');
    if (secureCodeIdTemp) {
       this.secureCodeId = parseInt(secureCodeIdTemp);
    }
    const secureCodeIndexTemp = window.location.href.indexOf('secure_code') + 'secure_code'.length + 1;
    const secureCodeTemp = window.location.href.slice(secureCodeIndexTemp);
    if (secureCodeTemp) {
      this.secureCode = secureCodeTemp;
    }
  }

  showMessagesToUser(): void {
    this.showMessages = true;
    const counterFn = () => {
      //console.log('executed counterFn');
      this.showMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  onSubmit(): any {
    //Obtain password
    this.messages = [];
    console.log('Validating New Password');
    const passwordEl = document.getElementById('new-password-text-id');
    // @ts-ignore
    const password = passwordEl.value;
    console.log('password: ' + password);
    if (!password) {
      console.log('password: ' + password + ' is not valid.');
      this.messages.push({
        field: 'New Password',
        detail: 'New Password: ' + password + ' is not valid.',
        severity: 'error'
      })
    }
    //Obtain repPassword
    console.log('Validating New Password Repeat');
    const repPasswordEl = document.getElementById('repeat-password-text-id');
    // @ts-ignore
    const repPassword: string = repPasswordEl.value;
    console.log('repPassword: ' + repPassword);
    if (!repPassword) {
      console.log('repPassword: ' + repPassword + ' is not valid.');
      this.messages.push({
        field: 'Repeated New Password',
        detail: 'Repeated New Password: ' + repPassword + ' is not valid.',
        severity: 'error'
      })
    }

    if (password !== repPassword) {
      this.messages.push({
        field: 'Password Mismatch',
        detail: 'Passwords do not match.',
        severity: 'error'
      });
    }
    if (this.messages.length > 0) {
      this.showMessagesToUser();
      return;
    }

    this.resetPasswordService.resetPassword(this.secureCodeId, this.secureCode ,password).subscribe(
      (result: any) => {
        if (result && result.body) {
          // Display success message of sending repPassword

          // 3 second timeout before navigating back to the
          setTimeout(() => {this.router.navigateByUrl('/app/login');}, 3000)

        }
      },  (error: any) => {
        //console.log('Reset Password Email: ' + JSON.stringify(error));
        this.messages.push({
          field: 'Reset Password Failure',
          detail: 'Reset Password failed to send...',
          severity: 'error'
        });
        this.showMessagesToUser();
      });

  }

  onCancel(): any {
    this.router.navigateByUrl('/app/login');
  }
}
